import { Box, Group, rem, Skeleton, Stack, Text } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import classes from "./AddWhatsAppPage.module.css";

/**
 * Esqueleto de carregamento da página de Adicionar WhatsApp.
 *
 * Reaproveita o mesmo layout/estilo do card (via CSS module) e renderiza o
 * texto fixo de imediato (pílula "Adicionar WhatsApp", copy de instrução e o
 * rótulo do campo). Os Skeletons cobrem apenas o que depende de dados: avatar e
 * nome do setor ativo, o título com o nome da empresa e os controles do passo.
 */
export function AddWhatsAppPageSkeleton() {
  return (
    <Box className={classes.pageWrapper}>
      {/* Botão de voltar — avatar e rótulo dependem do setor ativo */}
      <Group
        gap={rem(10)}
        wrap="nowrap">
        <Skeleton
          circle
          h={30}
          w={30}
        />
        <IconArrowLeft
          size={14}
          color="var(--mantine-color-dimmed)"
        />
        <Skeleton
          h={14}
          w={160}
          radius="sm"
        />
      </Group>

      {/* Pílula estática */}
      <Box className={classes.pagePill}>
        <Text
          size="xs"
          fw={600}
          c="dimmed">
          Adicionar WhatsApp
        </Text>
      </Box>

      <Box className={classes.card}>
        <Stack gap={0}>
          {/* Título "Novo WhatsApp em <empresa>" — depende do nome da empresa */}
          <Skeleton
            h={22}
            w={280}
            radius="sm"
            mb={12}
          />
          {/* Copy fixo */}
          <Text
            size="sm"
            c="dimmed"
            mb={24}>
            Escolha um nome para identificar essa linha de atendimento.
          </Text>
        </Stack>

        <Box className={classes.nameStepForm}>
          <Stack gap="sm">
            {/* Rótulo fixo do campo */}
            <Text
              size="sm"
              fw={500}
              c="var(--mantine-color-plain_text-0)">
              Nome do WhatsApp
            </Text>
            {/* Campo de texto */}
            <Skeleton
              h={42}
              radius="sm"
            />
            {/* Botão "Avançar" */}
            <Skeleton
              h={44}
              radius={rem(8)}
              mt={rem(16)}
            />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}
